export const USER_TYPE_MAPPING = {
    BENEFIT_ADMIN: "God Mode",
    TENANT_ADMIN: "Admin",
    STANDARD_USER: "Standard User",
    TRIAL_USER: "Trial"    
};
